"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWorkspaceLogoStoragePath = void 0;
var collectionBase_1 = require("../../functions/collection/collectionBase");
var fixConstants_1 = require("./../../constants/fixConstants");
var getWorkspaceLogoStoragePath = function (_a) {
    var workspaceId = _a.workspaceId;
    var path = "".concat((0, collectionBase_1.collectionBase)().workspaces, "/").concat(workspaceId, "/public/");
    return {
        originalPath: "".concat(path).concat(fixConstants_1.LOGO_FILE_NAME_PREFIX),
        thumbPath: "".concat(path).concat(fixConstants_1.THUMB_FILE_NAME_PREFIX).concat(fixConstants_1.LOGO_FILE_NAME_PREFIX),
    };
};
exports.getWorkspaceLogoStoragePath = getWorkspaceLogoStoragePath;
